import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import DisqusThread from 'react-disqus-comments-sso';
import { disqusCheckAndRefreshSSO } from '../../actions/auth';
import './styles.scss';
import { initializeGTMWithEvent } from '../../utils/googleTagManager';
import { eventGA } from '../../utils/googleAnalytics';
import CommentsCollapsibleHeaderTitle from './CommentsCollapsibleHeaderTitle';
import CommentsCTAButtons from './CommentsCTAButtons';

const defaultProps = {
  shortName: 'exploreorg',
  id: '',
  title: '',
  url: '',
  categoryId: '',
  api_key: '',
  remote_auth_s3: '',
  isVisible: false,
};

const propTypes = {
  shortName: PropTypes.string,
  id: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
  categoryId: PropTypes.string,
  api_key: PropTypes.string,
  remote_auth_s3: PropTypes.string,
  isVisible: PropTypes.bool,
};

class DisqusView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadComments: false,
    };
  }

  handleNewComment(comment) {
    initializeGTMWithEvent({
      event: 'buttonclick',
      buttondata: {
        action: 'Posted a comment',
        title: 'Comment',
      },
    });
    eventGA({
      category: 'engagement',
      action: 'Posted a comment',
      label: `${document.location.protocol}//${document.location.hostname}${document.location.pathname}${document.location.search}`,
      value: 10,
    });
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.remote_auth_s3 !== this.props.remote_auth_s3 || nextProps.id !== this.props.id
      || nextProps.commentsFullWidth !== this.props.commentsFullWidth || nextProps.isVisible !== this.props.isVisible;
  }

  componentWillMount() {
    this.props.dispatch(disqusCheckAndRefreshSSO());
    this.ssoInterval = setInterval(() => {
      this.props.dispatch(disqusCheckAndRefreshSSO());
    }, 1000 * 60);
  }

  componentWillReceiveProps(nextProps) {
    this.props.dispatch(disqusCheckAndRefreshSSO());

    if (nextProps.id !== this.props.id) {
      if (!nextProps.isVisible) {
        this.setState({ loadComments: false });
      }
    }
    if (nextProps.isVisible) {
      this.setState({ loadComments: true });
    }
  }

  componentWillUnmount() {
    clearInterval(this.ssoInterval);
    this.ssoInterval = null;
  }

  ssoConfig() {
    const baseUrl = window.location.origin;
    return {
      name: 'explore.org',
      button: 'https://explore.org/images/disqus-sso-login-button.png',
      icon: 'https://explore.org/images/favicon.png',
      url: `${baseUrl}/accounts/login/`,
      logout: `${baseUrl}/accounts/logout/`,
      width: '800',
      height: '400',
    };
  }

  render() {
    const {
      shortName,
      id,
      url,
      remote_auth_s3,
      isAuthenticated,
      livecamId,
      partner,
    } = this.props;
    const { loadComments } = this.state;

    let disqusComments = null;
    disqusComments = (isAuthenticated) ?
      (
        <DisqusThread
          shortname={shortName}
          identifier={id}
          api_key={DISQUS_PUBLIC_KEY}
          remote_auth_s3={remote_auth_s3}
          onNewComment={this.handleNewComment}
          sso={this.ssoConfig()}
          url={url}
        />
      ) : (
        <DisqusThread
          shortname={shortName}
          identifier={id}
          onNewComment={this.handleNewComment}
          sso={this.ssoConfig()}
          url={url}
        />
      );
    return (
      <Collapsible
        trigger={(<CommentsCollapsibleHeaderTitle />)}
        open
        triggerClassName="Collapsible__trigger container-rounded text-uppercase u-font-foundation-roman u-textSize-20 pY-15"
        triggerOpenedClassName="Collapsible__trigger is-open container-top-rounded text-uppercase u-font-foundation-roman u-textSize-20 pY-15"
        contentOuterClassName="info-box-content u-font-foundation-roman u-textSize-18"
        contentInnerClassName="disqus-height"
      >
        <CommentsCTAButtons partner={partner} livecamId={livecamId} />
        <div className="disqus_shorten">
          {loadComments ? (<div className="pl-3 pr-3 pb-3 pt-1">{disqusComments}</div>) : (<div className="pl-3 pr-3 pb-3 pt-1"/>)}
        </div>
      </Collapsible>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    url: state.currentItem.data.disqus_url,
    id: state.currentItem.data.disqus_id,
    remote_auth_s3: state.auth.disqus_sso,
    isAuthenticated: state.auth.isAuthenticated,
    commentsFullWidth: state.uiPreferences.commentsFullWidth,
    partner: state.currentItem.data.partner,
    livecamId: state.currentItem.data.id,
  };
};

DisqusView.propTypes = propTypes;
DisqusView.defaultProps = defaultProps;

export default connect(mapStateToProps)(DisqusView);
